import { render, staticRenderFns } from "./MultiselectTab.vue?vue&type=template&id=61f779c9&scoped=true&"
import script from "./MultiselectTab.vue?vue&type=script&lang=js&"
export * from "./MultiselectTab.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectTab.vue?vue&type=style&index=0&id=61f779c9&prod&lang=css&"
import style1 from "./MultiselectTab.vue?vue&type=style&index=1&id=61f779c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f779c9",
  null
  
)

export default component.exports